export const DEFAULT_OPTIONS = [
  { label: 'Day', value: 'day' },
  { label: 'Week', value: 'week' },
  { label: 'Month', value: 'month' },
];

export const SIZE = {
  sm: 'py-1.5 px-3 text-[13px]',
  md: 'py-2.5 px-5 text-[15px]',
  lg: 'py-3 px-7 text-[17px]',
};

export const TONE = {
  neutral: {
    track: 'bg-slate-100 border border-slate-200 dark:bg-slate-800/60 dark:border-slate-700',
    indicator: 'bg-slate-600 dark:bg-slate-500',
    text: 'text-slate-900 dark:text-slate-100',
    focus: 'focus-visible:ring-slate-400',
  },
  primary: {
    track: 'bg-indigo-50 border border-indigo-100 dark:bg-indigo-950/20 dark:border-indigo-900',
    indicator: 'bg-indigo-600 dark:bg-indigo-500',
    text: 'text-indigo-900 dark:text-indigo-100',
    focus: 'focus-visible:ring-indigo-400',
  },
  success: {
    track: 'bg-emerald-50 border border-emerald-100 dark:bg-emerald-950/20 dark:border-emerald-900',
    indicator: 'bg-emerald-600 dark:bg-emerald-500',
    text: 'text-emerald-900 dark:text-emerald-100',
    focus: 'focus-visible:ring-emerald-400',
  },
  warning: {
    track: 'bg-amber-50 border border-amber-100 dark:bg-amber-950/20 dark:border-amber-900',
    indicator: 'bg-amber-500 dark:bg-amber-400',
    text: 'text-amber-900 dark:text-amber-100',
    focus: 'focus-visible:ring-amber-400',
  },
};
